import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert } from "../../../utils";
import RoutesMap from "../../../route_control/RouteControl"

export const amcDashboardTodo = createAsyncThunk('amcDashboard', async ({ navigate, to_date }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `dashboard/amc`,
            params: {
                to_date: to_date || undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const amcDashboardSlice = createSlice({
    name: 'amcDashboard',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(amcDashboardTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                action?.meta?.arg?.navigate(RoutesMap.LOGIN.path)
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(amcDashboardTodo.rejected, (state, action) => {
        })
    }
})

export default amcDashboardSlice.reducer;
